/**
 * Funkcijos, kurias palaiko konkretus ClsfActivity įrašas.
 * Atspindi backend `OKIS.Domain.Shared.Activities.ClsfActivityFeature` enum.
 * Saugoma kaip `int[]` PostgreSQL stulpelyje `clsf_activity.features`.
 */
export enum ClsfActivityFeature {
	AnimalTransporter = 1,
	Mbm = 2,
	Sgp = 3,
	PermitNumber = 4,
}
